import { Form, FormField } from '#shared/form';
import validator from 'validator';
import { isDevBuildMode } from '#shared/helpers/buildMode';

const phoneWhiteList = [
  '79785555555',
  '78899334432',
  '70000003001',
  '70000003002',
  '70000003003',
  '70000003011',
  '79198661227',
  '79999999999',
  '70000000040',
  '70011110000',
  '79999999984',
  '79876543210',
  '71000146199',
  '79498738976',
  '73308844831',
  '79228221922',
  '79449000384',
  '79279567324',
  '79123654199',
  '79300000000',
  '79333333333',
  '79279345000',
  '79279345001',
  '79279345002',
  '79279345003',
  '79279345004',
  '79279345005',
  '79279345006',
  '79279345007',
  '79279345008',
  '79279345009',
  '79279345010',
];

export class SignInPhoneStepForm extends Form<{ phone: string; captcha: string }> {
  constructor() {
    super({
      phone: new FormField<string>(''),
      captcha: new FormField<string>(''),
    });

    this.formData.phone.addValidator({
      message: 'Неверный формат номера телефона',
      validateFn: (value) => {
        if (!value) return false;

        if (this.isPhoneInWhiteList(value)) return true;

        const formattedPhone = value.replace(/[^\d]/g, '');
        return validator.isMobilePhone(formattedPhone, 'ru-RU');
      },
    });

    this.formData.captcha.addValidator({
      message: 'Необходимо подтвердить, что вы не робот',
      validateFn: (value) => {
        if (this.isPhoneInWhiteList(this.formData.phone.value)) return true;
        return !!value;
      },
    });
  }

  public override reset() {
    this.formData.captcha.value = '';
    this.formData.phone.value = '';
  }

  private isPhoneInWhiteList(phone: string | undefined) {
    if (!phone) return false;

    const formattedPhone = phone.replace(/[^\d]/g, '');
    return isDevBuildMode() && phoneWhiteList.includes(formattedPhone);
  }
}
